import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {AmorphicService} from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import {AuthenticationService} from '../../../../../coverpath-common/angular/services/authentication/authentication.service';
import {BaseQuickQuoteService} from '../../../../../coverpath-common/angular/services/quote/base-quick-quote.service';
import { MMDirectCustomer } from '../../../../../coverpath-common/classes/mmdirect_subclasses/MMDirectCustomer';
import { MMDirectQuote } from '../../../../../coverpath-common/classes/quote/mm-direct/MMDirectQuote';

@Injectable()
export class QuickQuoteService extends BaseQuickQuoteService {

    controller;

    constructor(protected authenticationService: AuthenticationService,
                private amorphicService: AmorphicService,
                protected router: Router) {

        super(authenticationService, router);
        this.controller = amorphicService.controller;
    }

    getCurrentQuote(): MMDirectQuote {
        return this.controller.customer.mmdQuote as MMDirectQuote;
    }

    setCustomerQuote(): void {
        const quote: MMDirectQuote = this.controller.customer.mmdQuote as MMDirectQuote;
        const customer: MMDirectCustomer = this.controller.customer;

        customer.advanceApplicationProgress(1);
    }

}
